export const LESSON = '/lesson/'
export const LESSON_ALL = `${LESSON}all`
export const LESSON_SORTING = `${LESSON}sorting`
export const LESSON_HOMEWORK_UPLOAD = `${LESSON}homework`
export const LESSON_ASSESSMENT = `${LESSON}assessment/`
export const LESSON_ASSESSMENT_ALL = `${LESSON_ASSESSMENT}all`
